module.exports = __webpack_public_path__ + "assets/img/601.34f04f49.png";